export const config = {
    app: 'JAN'
}